import Chat from './pages';

export default Chat;
